import _Vue from 'vue'

export default {
  install(Vue: typeof _Vue): void {
    const overlayId = 'overlayLoading'

    const start = function (): void {
      // 既に表示済みの場合は終了
      const displayed = document.getElementById(overlayId)
      if (displayed) {
        return
      }

      const overlay = document.createElement('div')
      overlay.id = overlayId
      const loadingImage = document.createElement('div')
      loadingImage.id = 'loadingImage'
      overlay.appendChild(loadingImage)
      document.body.appendChild(overlay)
    }
    const complete = function (): void {
      const overlay = document.getElementById(overlayId)
      if (overlay) {
        overlay.remove()
      }
    }
    Vue.prototype.$loading = { start, complete }
  },
}

/**
 * インターフェース定義
 */
declare module 'vue/types/vue' {
  interface Vue {
    $loading: {
      start: () => void
      complete: () => void
    }
  }
}
